import { useFormContext } from "react-hook-form";
import styled from "styled-components";

const FieldTextAreaStyled = styled.textarea`
  min-height: 11rem;
  padding: 1.5rem 1.6rem 1.9rem;
  border: 1px solid #a8b2ba;
  border-radius: 0.8rem;
  font-family: "Pretendard", sans-serif;
  box-sizing: border-box;

  &::-moz-placeholder {
    color: #c9c9c9;
  }

  &::placeholder {
    color: #c9c9c9;
  }
`;

type FieldTextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const FieldTextArea = ({ name, ...props }: FieldTextAreaProps) => {
  const { register } = useFormContext();
  return (
    <>
      <FieldTextAreaStyled {...register(name!)} {...props} />
    </>
  );
};

export default FieldTextArea;
